import {
    ABOUT_US,
    CARDS,
    COMMERCIAL_BANKING,
    CONTACT,
    DIGITAL_ASSETS_BANKING,
    FAQ,
    PRIVATE_BANKING,
    TRADE_FINANCE
} from "./Constants";
import AboutUs from "../publicPages/aboutUs/AboutUs";
import PrivateBanking from "../publicPages/privateBanking/PrivateBanking";
import CommercialBanking from "../publicPages/commercialBanking/CommercialBanking";
import Cards from "../publicPages/cards/Cards";
import DigitalAssetsBanking from "../publicPages/digitalAssetsBanking/DigitalAssetsBanking";
import Faq from "../publicPages/faq/Faq";
import TradeFinance from "../publicPages/tradeFinance/TradeFinance";
import Contact from "../publicPages/contact/Contact";

export const publicRoutes = [
    {
        path: ABOUT_US,
        titleKey: "routes.aboutUs",  // Translatable title key
        component: <AboutUs />
    },
    {
        path: PRIVATE_BANKING,
        titleKey: "routes.privateBanking",
        component: <PrivateBanking />
    },
    {
        path: COMMERCIAL_BANKING,
        titleKey: "routes.commercialBanking",
        component: <CommercialBanking />
    },
    {
        path: CARDS,
        titleKey: "routes.cards",
        component: <Cards />
    },
    {
        path: DIGITAL_ASSETS_BANKING,
        titleKey: "routes.digitalAssetsBanking",
        component: <DigitalAssetsBanking />
    },
    {
        path: TRADE_FINANCE,
        titleKey: "routes.tradeFinance",
        component: <TradeFinance />
    },
    {
        path: FAQ,
        titleKey: "routes.faq",
        component: <Faq />
    },
    {
        path: CONTACT,
        titleKey: "routes.contact",
        component: <Contact />
    },
];
